import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Printer, DownloadSimple, X } from "@phosphor-icons/react";

/** Anteprima PDF in-app: l'utente decide se stampare, salvare o scaricare. */
export const PdfViewerHost = () => {
  const [doc, setDoc] = useState(null);
  const frame = useRef(null);

  useEffect(() => {
    const onOpen = (e) => setDoc(e.detail);
    window.addEventListener("app:open-pdf", onOpen);
    return () => window.removeEventListener("app:open-pdf", onOpen);
  }, []);

  const close = () => {
    if (doc?.url) setTimeout(() => window.URL.revokeObjectURL(doc.url), 500);
    setDoc(null);
  };

  const print = () => {
    try { frame.current?.contentWindow?.focus(); frame.current?.contentWindow?.print(); }
    catch { window.open(doc.url, "_blank"); }
  };

  const save = () => {
    const a = document.createElement("a");
    a.href = doc.url;
    a.download = doc.filename || "documento.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  if (!doc) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-black/70 flex flex-col" data-testid="pdf-viewer">
      <div className="flex items-center gap-2 px-3 py-2 bg-card border-b border-border">
        <span className="text-sm font-semibold truncate" data-testid="pdf-viewer-name">{doc.filename}</span>
        <div className="ml-auto flex gap-2">
          <Button size="sm" className="rounded-sm font-semibold" onClick={print} data-testid="pdf-print">
            <Printer size={15} className="mr-1.5" /> STAMPA
          </Button>
          <Button size="sm" variant="outline" className="rounded-sm" onClick={save} data-testid="pdf-download">
            <DownloadSimple size={15} className="mr-1.5" /> SCARICA
          </Button>
          <Button size="sm" variant="ghost" className="rounded-sm" onClick={close} data-testid="pdf-close">
            <X size={16} />
          </Button>
        </div>
      </div>
      <iframe ref={frame} src={doc.url} title={doc.filename} className="flex-1 w-full bg-white"
        data-testid="pdf-frame" />
    </div>
  );
};
